import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'

import {useMergeMethodContext} from '../contexts/MergeMethodContext'
import {useMergeBoxQueryKey} from '../page-data/loaders/use-merge-box-query-key'
import {
  stackMergeabilityPageDataQueryKey,
  useStackMergeabilityQuery,
} from '../page-data/loaders/use-stack-mergeability-page-data'
import {
  EMPTY_CHANNELS,
  useMergeabilityLiveUpdates,
  type MergeabilityLiveUpdateChannels,
} from '../hooks/use-mergeability-live-updates'

export function useStackMergeabilityUpdates({
  basePageDataUrl,
  currentPullRequestId,
  channels,
}: {
  basePageDataUrl: string
  currentPullRequestId: string
  channels: MergeabilityLiveUpdateChannels | null
}) {
  const {mergeMethod} = useMergeMethodContext()
  const mergeBoxQueryKey = useMergeBoxQueryKey()
  // Stack eligibility uses persisted PR states from the parent merge-box snapshot.
  useInvalidateOnAliveUpdate(channels?.stateChannel, mergeBoxQueryKey)
  useStackMergeabilityQuery({basePageDataUrl, currentPullRequestId, mergeMethod, enabled: false})
  useMergeabilityLiveUpdates({
    channels: channels ?? EMPTY_CHANNELS,
    queryKey: stackMergeabilityPageDataQueryKey(basePageDataUrl, currentPullRequestId),
    throttleTime: 5000,
  })
}
